<template>
	<div>
		<el-card class="box-card">
			<el-row>
			  <el-col :span="1">
				  <el-avatar style="width:60px;height:60px;" size="large" :src="res.spongeman.head_img"></el-avatar>
			  </el-col>
			  <el-col :span="4">
			  	<h3 style="color:rgb(64, 158, 255);">{{res.spongeman.user_name}}</h3>
			  </el-col>
			  <el-col :span="3" style="margin-top: 20px;">
			  	<i style="color:rgb(64, 158, 255);" class="el-icon-money"> </i><span> 账户余额：</span>
				<span style="color:red;"> {{res.spongeman.money}}</span>
			  </el-col>
			</el-row>
		</el-card>
		<el-card class="box-card" style="margin-top: 10px;">
			<el-descriptions title="订单">
				<el-descriptions-item label="已接单订单">
					<el-link @click="href2" type="primary">{{res.accept_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已下单订单">
					<el-link @click="href2" type="primary">{{res.down_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已发货订单">
					<el-link @click="href2" type="primary">{{res.send_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已收货订单">
					<el-link @click="href2" type="primary">{{res.receipt_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已评价订单">
					<el-link @click="href2" type="primary">{{res.appraise_order}}</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="已取消订单">
					<el-link @click="href2" type="primary">{{res.cancel_order}}</el-link>
				</el-descriptions-item>
			</el-descriptions>
		</el-card>
		
		<!-- <el-card class="box-card" style="margin-top: 10px;">
			<el-descriptions title="待办事项">
				<el-descriptions-item label="未读站内信">
					<el-link @click="href3" type="danger">{{res.no_read_msg}}</el-link>
				</el-descriptions-item>
			</el-descriptions>
		</el-card> -->
		
		<el-card class="box-card" style="margin-top: 10px;">
			<el-descriptions title="在线客服" direction="vertical" :column="4">
				<el-descriptions-item label="QQ">
					<el-link type="primary" :href="res.qq" target="_bank">
						<el-image style="width: 92px; height: 22px" src="/QQ.png" fit="fill"></el-image>
					</el-link>
				</el-descriptions-item>
				<el-descriptions-item label="微信">
					<el-image style="width: 140px; height: 140px" :src="res.wx" fit="fill"></el-image>
				</el-descriptions-item>
			</el-descriptions>
		</el-card>
	</div>
</template>

<script>
	import {
		index
	} from '@/api/jd_task'
	import Qs from 'qs'
	import weekEcharts from '@/components/Jd/weekEcharts'
	export default {
		name: 'Dashboard',
		components: {
			weekEcharts
		},
		data() {
			return {
				res: {
					'ing_task': 0,
					'complete_task': 0,
					'accept_order': 0,
					'down_order': 0,
					'send_order': 0,
					'receipt_order': 0,
					'appraise_order': 0,
					'cancel_order': 0,
					'qq': '',
					'wx': '',
					'spongeman':{},
					'no_read_msg':0,
				},
			}
		},
		created() {
			this.getData();
		},
		methods: {
			getData() {
				index(Qs.stringify()).then(response => {
					let r = response.result;
					this.res.ing_task = r.ing_task;
					this.res.complete_task = r.complete_task;
					this.res.accept_order = r.accept_order;
					this.res.down_order = r.down_order;
					this.res.send_order = r.send_order;
					this.res.receipt_order = r.receipt_order;
					this.res.appraise_order = r.appraise_order;
					this.res.cancel_order = r.cancel_order;
					this.res.qq = "https://wpa.qq.com/msgrd?v=3&uin=" + r.kf.qq + "&site=qq&menu=yes";
					this.res.wx = r.kf.wx;
					this.res.spongeman = r.spongeman;
					this.res.no_read_msg = r.no_read_msg;
				})
			},
			href2() {
				//路由跳转
				this.$router.push({
					path: '/task/order_list',
				});
			},
			href3() {
				//路由跳转
				this.$router.push({
					path: '/user/message',
				});
			},
		}
	}
</script>

<style>
</style>
